import   React               ,
       { useEffect           ,
         useState            }  from "react";

import   classNames             from 'classnames';

import   styles                 from './LegalStructureList.module.scss';

import   TabularDisplay         from "../../widget/dataDisplay/tables/TabularDisplay";
import   WidgetFrame            from '../../widget/navigation/WidgetFrame';
import   Tabs2                  from '../../widget/navigation/Tabs2';
import   Field                  from "../../widget/inputs/Field";
import   OpenStreetMap          from "../../widget/dataDisplay/maps/OpenStreetMap";
import   ExtendablePanel        from "../../widget/windows/ExtendablePanel";
import   AnimatedWaitingIcon2   from '../../widget/animations/animatedWaitingIcon2';
import   Trigger                from '../../widget/actuators/Trigger';
import   Icon                   from "../../widget/images/Icon";


		 
import { groupData                        ,
         GroupedData                      ,
         initializedGroupedData                }  from "../../../dataTypes/dataSetManagment/regroupData";		 
		 

import { LegalStructure      }  from '../../../dataTypes/legalStructureManagment/types';

import { User                }  from '../../../dataTypes/userManagment/types';

import { getLegalStructures               }  from '../../../backendServices/legalStructureManagment/api_legalStructure';



import   LegalStructureSheet                 from './LegalStructureSheet'; 

export const LegalStructureList = () => {

  const [ legalStructureList      , setLegalStructureList      ] = useState<LegalStructure[]>([]);
  const [ legalStructureList2     , setLegalStructureList2     ] = useState<LegalStructure[]>([]);
  const [ groupedData             , setGroupedData             ] = useState<GroupedData<LegalStructure>>(initializedGroupedData<LegalStructure>())
  const [ showWaitingIcon         , setShowWaitingIcon         ] = useState(false);

  const [ filter                  , setFilter                  ] = useState('');



  const [ creationMode            , setCreationMode            ] = useState(false);

  const [ users                   ] = useState<User[]>([]);


  const init = async () => {
	  

        const legalStructuresResult = await getLegalStructures();

        if (legalStructuresResult.payload) 
		 {
          setLegalStructureList2 (legalStructuresResult.payload);
          setLegalStructureList  (legalStructuresResult.payload);
         }
  }

  useEffect(() => {
	
    const fetchData = async () => {
    	
	  try 
	   {
        setShowWaitingIcon(true);

        init ()
/*
        const usersResult = await getUserList();

        if (usersResult.payload)
		 {
          setUsers (usersResult.payload);
         }*/
      }
	  catch (error) 
	   {
        console.error('Error fetching data:', error);
       } 
	  finally 
	   {
        setShowWaitingIcon(false);
       }
    };

    fetchData();
  }, []); 

  // Effet pour appliquer le filtrage
  useEffect(() => {
    if (!legalStructureList2.length) return;

    const filteredList = filterLegalStructures(legalStructureList2, filter);
    setLegalStructureList(filteredList);
    
    const groupedDataLocal = groupData<LegalStructure>(filteredList, getGroupKey());
    setGroupedData(groupedDataLocal);
  }, [filter, legalStructureList2]); 

  // Fonction de filtrage des structures juridiques
  const filterLegalStructures = (originalList: LegalStructure[], filterText: string): LegalStructure[] => {
    const query = filterText.trim().toLowerCase();
  
    // Si le champ de recherche est vide, on retourne la liste complète
    if (!query) return originalList;

    const asLower = (value: any) => {
      if (value === null || value === undefined) return '';
      // On ne traite que les types string et number
      if (typeof value === 'string' || typeof value === 'number') {
        return String(value).toLowerCase();
      }
      return '';
    };

    return originalList.filter(structure =>
      // Recherche dans les champs principaux (string/number uniquement)
      ['siren', 'tradeName', 'companyName'].some(key => {
        const value = structure[key as keyof LegalStructure];
        const searchableValue = asLower(value);
        return searchableValue && searchableValue.includes(query);
      })
    );
  };

  const handleStructureDelete = ( structure : LegalStructure) => {
	  
	  
  }

  const columns = [
  { header : "Siren"              , accessor: "businessRegistrationNumber" as keyof LegalStructure },
  { header : "Enseigne"           , accessor: "tradeName"                  as keyof LegalStructure },
  { header : "Nom"                , accessor: "companyName"                as keyof LegalStructure },
];

const actions = {
    header   : 'Actions',
    width    : '150px',
    align    : 'center' as const,  
    renderer : ( structure : LegalStructure , 
                 rowIndex  : number           , 
                 groupKey? : string           ,
                 isExpanded? : boolean        ) => (  // NOUVEAU paramètre
                     
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <Icon 
                          name="trashCan"   
                          onClick={() => handleStructureDelete(structure)}   
                          color={isExpanded ? "#FFFFFF" : "#000000"}  // MODIFIÉ: couleur conditionnelle
                          hoverColor="#4421AA" 
                        />
                      </div>
                   )
  }
	
  const getGroupKey = () => {

    return (legalStructure: LegalStructure) => {
      const match = legalStructure.companyName.match(/[a-zA-Z]/);
      const letter = match ? match[0].toUpperCase() : '#'; // ou autre fallback

      return {
        key: letter,
        renderer: (val: string) => val,
      };
    };
  }

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
  };

  const handleNewLegalStructureCreationClick = () => {

    setCreationMode (true)
  }

  const onLegalStructureCreationCancel = () => {

    setCreationMode (false)
  }

  const onNewLegalStructureCreation = () => {

    setCreationMode (false)
  
    init ()
  }



  return (

    <div className={styles.root}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}

      {
       creationMode
       ?
       (
         <LegalStructureSheet users            = {users}
                              creationMode     = {true}
                              onCreationCancel = {onLegalStructureCreationCancel} 
							  onCreationMade   = {onNewLegalStructureCreation} />
       )
       :
       (
         <>
           <div className={styles.controlPanel}>

              <div className={styles.filters}>
                 <WidgetFrame name               = "Rechercher :"
                              labelTextPosition  = "right"
                              labelBlockPosition = "left"
                              classNameGrid      = {classNames(styles.grid_frame)} >
                   <Field type        = "text"
                          placeholder = "Saisissez un nom, enseigne ou SIREN..."
                          value       = {filter}
                          onChange    = {handleFilterChange} />
                 </WidgetFrame>
              </div>

             <div className={classNames(styles.creationButton)}>
               <Trigger name    = "Créer une entreprise"
                        onClick = {handleNewLegalStructureCreationClick}
                        variant = "tailwind2"  />
             </div>
           </div>

           {
            !showWaitingIcon && 
            (
             legalStructureList.length === 0
             ?
             (
              <div className={styles.noDataMessage}>
                {filter ? 'Aucune entreprise ne correspond à votre recherche' : 'Aucune donnée à afficher pour la période considérée'}
              </div>
             )
             :
             (
              <div className={styles.resultSection}>
                <div className={styles.tableSection}>
                 <TabularDisplay 
  groupedData                = {groupedData}
  columns                    = {columns}
  actionColumn               = {actions}
  showGroupHeaders           = {false}
  singleRowExpansion         = {true}
  expandedRowBackgroundColor = "#6632FF"
  expandedRowColor           = "#FFFFFF"
  rowDetailRenderer          = {rowData => {
    // Calcul des coordonnées basé sur rowData (legalStructure)
    const coordinates = [{
      lat   : rowData.latitude ?? 0,
      lng   : rowData.longitude ?? 0,
      info1 : rowData.tradeName || "N/A",
      info2 : rowData.companyName || "N/A",
      color : 'violet'
    }];
    return (
      <Tabs2 tabs = {[
        {
          label    : 'Informations',
          children : <LegalStructureSheet users          = {users}
                                          legalStructure = {rowData} />
        },
        {
          label    : 'Carte',
          children : <ExtendablePanel width={556} height={556} logoUrl="/images/logo.png" logoPosition="bottomLeft">
                       <OpenStreetMap coordinates={coordinates} />
                     </ExtendablePanel>
        },
      ]}  />
    );
  }}  
/>
                </div>
                {/*filter && (
                  <div className={styles.filterInfo}>
                    {legalStructureList.length} entreprise(s) trouvée(s) pour "{filter}"
                  </div>
                )*/}
              </div>
             )
            )
           }
         </>
       )
      }

    </div>
  );
};

export default LegalStructureList;